// Select all the links with the class .full-unstyled-link
const links = document.querySelectorAll('.card-wrapper .full-unstyled-link');

// Loop through each link and add focus event listeners
links.forEach((link) => {
  link.addEventListener('focus', (event) => {
    // Get the closest parent with the .card-wrapper class
    const cardWrapper = event.target.closest('.card-wrapper');
    // Add the "focused" class to the parent .card-wrapper
    cardWrapper.classList.add('focused');
  });

  // Remove the "focused" class when the link loses focus
  link.addEventListener('blur', (event) => {
    const cardWrapper = event.target.closest('.card-wrapper');
    cardWrapper.classList.remove('focused');
  });
});
